import { useEffect, useRef, useState } from "react";
import { useSocket } from "../lib/client.ts";

// The digital card: this phone sits at brow height, screen toward the guesser's face.
// It shows a solid colour or nothing, with no text during a trial, so it adds no cue of its own.

export function CardView() {
  const [hex, setHex] = useState<string | null>(null);
  const [everOn, setEverOn] = useState(false);
  const wake = useRef<WakeLockSentinel | null>(null);
  const { connected } = useSocket("card", (m) => {
    if (m.t === "card") {
      setHex(m.hex);
      if (m.on) setEverOn(true);
    }
  });

  useEffect(() => {
    const acquire = async () => {
      try { wake.current = await navigator.wakeLock?.request("screen"); } catch { /* Not available everywhere. */ }
    };
    void acquire();
    const again = () => { if (document.visibilityState === "visible") void acquire(); };
    document.addEventListener("visibilitychange", again);
    return () => { document.removeEventListener("visibilitychange", again); void wake.current?.release(); };
  }, []);

  useEffect(() => {
    document.documentElement.classList.add("card-page");
    return () => document.documentElement.classList.remove("card-page");
  }, []);

  return (
    <main className="card-screen" style={{ background: hex ?? "#000" }} data-card-hex={hex ?? ""} data-testid="card-screen"
      onClick={() => { void document.documentElement.requestFullscreen?.().catch(() => {}); }}>
      {!everOn && (
        <div className="card-hint">
          <p className="eyebrow">{connected ? "Card paired" : "Connecting"}</p>
          <p>Turn brightness up and lock rotation.</p>
          <p>Prop this phone at brow height or higher, 30 to 40 cm from your face, with the screen toward you.</p>
          <p>The screen goes black when your turn starts. Keep it out of your call camera's shot.</p>
        </div>
      )}
    </main>
  );
}
